import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  flex50: {
    flex: 0.5,
  },
  amountText: {
    color: theme.palette.themePrimary,
  },
  label: {
    color: theme.palette.themePrimary,
    marginRight: 6,
  },
  amountRow: {
    justifyContent: 'space-between',
  },
}));
